export const clickStreamConstants = {
  LH_DOCUMENT_DOWNLOAD_CLICKED: {
    name: 'LH_DOCUMENT_DOWNLOAD_CLICKED',
    description: 'Document download clicked'
  },
  LH_DOCUMENT_DOWNLOAD_SUCCESS: {
    name: 'LH_DOCUMENT_DOWNLOAD_SUCCESS',
    description: 'Document download success clicked'
  },
  LH_DOCUMENT_DOWNLOAD_FAILED: {
    name: 'LH_DOCUMENT_DOWNLOAD_FAILED',
    description: 'Document download failed'
  },
  LH_DOCUMENT_VIEWED: {
    name: 'LH_DOCUMENT_VIEWED',
    description: 'Document viewed'
  }
};
